/* euroguard · Página «Ensayos y certificaciones»
   - Fichas por cartucho: pestañas + tarjetas del selector de la cabecera; sincroniza el hash (#cartucho-classic).
   - Enlaces con ?q=Chlore (portada): resalta la familia coincidente en «Qué reduce cada cartucho» y baja hasta ella.
   - Editor de temas: al seleccionar un bloque de cartucho se muestra su ficha. */
(function () {
  'use strict';
  if (window.__egTesting) return;
  window.__egTesting = true;

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function initTabs() {
    var root = document.querySelector('[data-eg-tc]');
    if (!root || root.dataset.tcReady) return;
    root.dataset.tcReady = '1';
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-eg-tc-panel]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-eg-tc-tab]'));
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-eg-tc-pick]'));
    var keys = panels.map(function (p) { return p.getAttribute('data-eg-tc-panel'); });
    if (!keys.length) return;

    function keyFromHash() {
      var h = (location.hash || '').replace(/^#/, '').toLowerCase();
      if (h.indexOf('cartucho-') === 0) h = h.slice(9);
      return keys.indexOf(h) > -1 ? h : null;
    }

    function activate(key, opts) {
      opts = opts || {};
      if (keys.indexOf(key) === -1) key = keys[0];
      panels.forEach(function (p) {
        var on = p.getAttribute('data-eg-tc-panel') === key;
        p.hidden = !on;
      });
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-eg-tc-tab') === key;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      cards.forEach(function (c) {
        c.setAttribute('aria-pressed', c.getAttribute('data-eg-tc-pick') === key ? 'true' : 'false');
      });
      if (opts.updateHash && history.replaceState) {
        try { history.replaceState(null, '', '#cartucho-' + key); } catch (e) { /* noop */ }
      }
      if (opts.scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(t.getAttribute('data-eg-tc-tab'), { updateHash: true }); });
      t.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        var next = tabs[(i + dir + tabs.length) % tabs.length];
        next.focus();
        activate(next.getAttribute('data-eg-tc-tab'), { updateHash: true });
      });
    });
    cards.forEach(function (c) {
      c.addEventListener('click', function () { activate(c.getAttribute('data-eg-tc-pick'), { updateHash: true, scroll: true }); });
    });
    window.addEventListener('hashchange', function () {
      var k = keyFromHash();
      if (k) activate(k, { scroll: true });
    });

    var initial = keyFromHash();
    activate(initial || keys[0], { scroll: !!initial });
    window.__egTestingActivate = activate;
  }

  /* ?q=Chlore → resalta la familia con esa palabra clave */
  function initQuery() {
    var m = /[?&]q=([^&#]+)/.exec(location.search);
    if (!m) return;
    var q = norm(decodeURIComponent(m[1].replace(/\+/g, ' '))).trim();
    if (!q) return;
    var rows = Array.prototype.slice.call(document.querySelectorAll('[data-eg-terms]'));
    var hit = null;
    rows.forEach(function (r) {
      var terms = norm(r.getAttribute('data-eg-terms')).split(/[,\s]+/);
      var match = terms.some(function (t) { return t && (t === q || t.indexOf(q) === 0 || q.indexOf(t) === 0); });
      r.classList.toggle('is-hit', match);
      if (match && !hit) hit = r;
    });
    if (hit && !location.hash) {
      var jump = function () {
        var r = hit.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) hit.scrollIntoView({ behavior: 'auto', block: 'center' });
      };
      setTimeout(jump, 100);
      window.addEventListener('load', function () { setTimeout(jump, 250); });
    }
  }

  function boot() { initTabs(); initQuery(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () {
    var root = document.querySelector('[data-eg-tc]');
    if (root) delete root.dataset.tcReady;
    initTabs();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target && e.target.closest && e.target.closest('[data-eg-tc-panel]');
    if (panel && window.__egTestingActivate) window.__egTestingActivate(panel.getAttribute('data-eg-tc-panel'));
  });
})();
